import { Link as LinkIcon } from "@phosphor-icons/react";

import type { KeywordTypes } from "common/types";

import { KEYWORD_OPTIONS } from "../constants";

interface KeywordIconProps {
  type: KeywordTypes;
  isRaw?: boolean;
}

export default function KeywordIcon({ type, isRaw = false }: KeywordIconProps) {
  const isGeneral = type === "general";

  const Icon = isRaw && isGeneral ? LinkIcon : KEYWORD_OPTIONS[type].icon;

  return <Icon weight={isGeneral ? "regular" : "fill"} />;
}
